import React from "react";
import Message from "./Message";
import MessageBlock from "../../Organisms/MessagesBlock";
import FirstMessageSkeleton from "./FirstMessageSkeleton";
import IronFlag from "../../../assets/img/iron-flag.svg"; // Verifique o caminho

const MessageList = ({
  groupedMessages,
  userCodePairs,
  isSystemMessage,
  diff,
  handleDownloadDocx,
  containerRef,
  messagesEndRef,
  showFirstMessageSkeleton,
  OnLikeButtonPress,
  handleWheel,
}) => {
  return (
    <MessageBlock ref={containerRef} onWheel={handleWheel}>
      {groupedMessages.map((msg, index) => {
        const codePair = userCodePairs.find(
          (pair) => pair.assistantIndex === index
        );
        return (
          <Message
            key={msg.id || index}
            msg={msg}
            codePair={codePair}
            diff={diff}
            handleDownloadDocx={handleDownloadDocx}
            OnLikeButtonPress={OnLikeButtonPress}
            IronFlag={IronFlag}
          />
        );
      })}

      {showFirstMessageSkeleton && <FirstMessageSkeleton />}

      {/* Elemento dummy para rolagem */}
      <div ref={messagesEndRef} />
    </MessageBlock>
  );
};

export default MessageList;
